import { MadSDKAPIError } from "../../errors/base";
export class PixelsFetchFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PixelsFetchFailed);
        }
        this.name = "PixelsFetchFailed";
        this.message = "Failed to retrieve pixels. Please try again at a later time.";
    }
}
export class PixelSaveFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PixelSaveFailed);
        }
        this.name = "PixelSaveFailed";
        this.message = "Failed to save pixel. Please try again at a later time.";
    }
}
export class PixelIdCreationFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PixelIdCreationFailed);
        }
        this.name = "PixelIdCreationFailed";
        this.message = "Failed to create unique ID for pixel. Please try again at a later time.";
    }
}
export class PixelHistoryFetchFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PixelHistoryFetchFailed);
        }
        this.name = "PixelHistoryFetchFailed";
        this.message = "Failed to retrieve pixel history. Please try again at a later time.";
    }
}
export class PixelLastReceivedFetchFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PixelLastReceivedFetchFailed);
        }
        this.name = "PixelLastReceivedFetchFailed";
        this.message =
            "Failed to retrieve pixel last received dates. Please try again at a later time.";
    }
}
export class InvalidPixelLastReceivedData extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, InvalidPixelLastReceivedData);
        }
        this.name = "InvalidPixelLastReceivedData";
        this.message = "Pixel last received data is not in an expected format.";
    }
}
//# sourceMappingURL=errors.js.map